import styled, { css } from 'styled-components';

export type NavButtonBaseProps = Readonly<{
  disabled?: boolean;
  level?: number;
}>;

const buttonNotDisabled = ({ disabled = false }: NavButtonBaseProps) => {
  if (!disabled) {
    return css`
      cursor: pointer;
      outline: none;

      &:hover {
        background-color: ${({ theme }) => theme.scTheme.palette.greyscale[10]};
      }

      &:focus-within {
        box-shadow: ${({ theme }) => theme.scTheme.shadows.focus.primary.outer}
      }
    `;
  }
  return null;
};

const NavButtonBase = styled.button<NavButtonBaseProps>`
  flex-direction: column;
  background-color: ${({ theme }) => theme.scTheme.palette.inverted.white};
  border: none;
  border-radius: ${({ theme }) => theme.scTheme.borders.radii.md};
  display: flex;
  ${buttonNotDisabled}
  padding-left: ${({ theme, level = 0 }) => `calc(${theme.scTheme.space[500]} + ${theme.scTheme.space[300]} * ${level})`};
  padding-right: ${({ theme }) => theme.scTheme.space[500]};
  padding-bottom: calc(${({ theme }) => `${theme.scTheme.space[300]} + ${theme.scTheme.space[100]}`});
  padding-top: calc(${({ theme }) => `${theme.scTheme.space[300]} + ${theme.scTheme.space[100]}`});
  text-decoration: none;
  width: 100%;
`;

export default NavButtonBase;
